import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import headerEn from "./locales/en/header.json";
import headerFr from "./locales/fr/header.json";
import authEn from "./locales/en/auth.json";
import authFr from "./locales/fr/auth.json";
import signupEn from "./locales/en/signUp.json";
import signupFr from "./locales/fr/signUp.json";
import footerEn from "./locales/en/footer.json";
import footerFr from "./locales/fr/footer.json";
import myGarageEn from "@common/locales/en/dashboard/myGarage/myGarage.json";
import myGarageFr from "@common/locales/fr/dashboard/myGarage/myGarage.json";
import sellMyCarEn from "@common/locales/en/dashboard/myGarage/sellMyCar.json";
import sellMyCarFr from "@common/locales/fr/dashboard/myGarage/sellMyCar.json";
import generalInfoFormEn from "@common/locales/en/dashboard/myGarage/generalInfoForm.json";
import generalInfoFormFr from "@common/locales/fr/dashboard/myGarage/generalInfoForm.json";
import questionareFormEn from "@common/locales/en/dashboard/myGarage/questionnareForm.json";
import questionareFormFr from "@common/locales/fr/dashboard/myGarage/questionnareForm.json";
import sidebarEn from "./locales/en/dashboard/sidebar.json";
import sidebarFr from "./locales/fr/dashboard/sidebar.json";
import userHeaderEn from "./locales/en/userHeader.json";
import userHeaderFr from "./locales/fr/userHeader.json";
import upcomingCarsEn from "./locales/en/dashboard/upcomingCars/upcomingCars.json";
import upcomingCarsFr from "./locales/fr/dashboard/upcomingCars/upcomingCars.json";
import buyNowEn from "./locales/en/dashboard/buyNow/buyNow.json";
import buyNowFr from "./locales/fr/dashboard/buyNow/buyNow.json";
import liveAuctionEn from "./locales/en/dashboard/liveAuction/liveAuction.json";
import liveAuctionFr from "./locales/fr/dashboard/liveAuction/liveAuction.json";
import carsInNegotiationEn from "./locales/en/dashboard/carsNegotiation/carsNegotiation.json";
import carsInNegotiationFr from "./locales/fr/dashboard/carsNegotiation/carsNegotiation.json";
import specificationEn from "@common/locales/en/dashboard/myGarage/specifications.json";
import specificationFr from "@common/locales/fr/dashboard/myGarage/specifications.json";
import carEstimateAuctionEn from "@common/locales/en/dashboard/myGarage/carEstimateAuction.json";
import carEstimateAuctionFr from "@common/locales/fr/dashboard/myGarage/carEstimateAuction.json";
import galleryEn from "@common/locales/en/dashboard/myGarage/gallery.json";
import galleryFr from "@common/locales/fr/dashboard/myGarage/gallery.json";
import myOrdersEn from "./locales/en/dashboard/myOrders/myOrders.json";
import myOrdersFr from "./locales/fr/dashboard/myOrders/myOrders.json";
import carContainerEn from "@common/locales/en/carContainer.json";
import carContainerFr from "@common/locales/fr/carContainer.json";
import vehicleAddedSuccessModalEn from "@common/locales/en/components/vehicleAddedSuccessModal.json";
import vehicleAddedSuccessModalFr from "@common/locales/fr/components/vehicleAddedSuccessModal.json";
import priceIndicatorEn from "@common/locales/en/components/priceIndicator.json";
import priceIndicatorFr from "@common/locales/fr/components/priceIndicator.json";
import carAddedToSaleEn from "@common/locales/en/components/carAddedToSale.json";
import carAddedToSaleFr from "@common/locales/fr/components/carAddedToSale.json";
import bidHistoryEn from "@common/locales/en/components/bidHistory.json";
import bidHistoryFr from "@common/locales/fr/components/bidHistory.json";
import timeLeftEn from "@common/locales/en/components/timeLeft.json";
import timeLeftFr from "@common/locales/fr/components/timeLeft.json";
import saleInformationEn from "@common/locales/en/components/saleInformation.json";
import saleInformationFr from "@common/locales/fr/components/saleInformation.json";
import buyNowCarDetailReadOnlyEn from "@common/locales/en/dashboard/buyNow/buyNowCarDetailReadOnly.json";
import buyNowCarDetailReadOnlyFr from "@common/locales/fr/dashboard/buyNow/buyNowCarDetailReadOnly.json";
import negotiationListEn from "@common/locales/en/components/negotiationList.json";
import negotiationListFr from "@common/locales/fr/components/negotiationList.json";
import carBiddingNegotiationEn from "@common/locales/en/components/carBiddingNegotiation.json";
import carBiddingNegotiationFr from "@common/locales/fr/components/carBiddingNegotiation.json";
import carsInNegotiationDetailsEn from "@common/locales/en/dashboard/carsNegotiation/carsInNegotiationDetails.json";
import carsInNegotiationDetailsFr from "@common/locales/fr/dashboard/carsNegotiation/carsInNegotiationDetails.json";
import carDetailsEn from "@common/locales/en/components/carDetails.json";
import carDetailsFr from "@common/locales/fr/components/carDetails.json";
import rejectedCarsEn from "@common/locales/en/dashboard/rejectedCars/rejectedCars.json";
import rejectedCarsFr from "@common/locales/fr/dashboard/rejectedCars/rejectedCars.json";
import profileEn from "@common/locales/en/dashboard/profile/profile.json";
import profileFr from "@common/locales/fr/dashboard/profile/profile.json";
import commonEn from "@common/locales/en/common.json";
import commonFr from "@common/locales/fr/common.json";

const resources = {
  en: {
    header: headerEn,
    auth: authEn,
    myGarage: myGarageEn,
    sellMyCar: sellMyCarEn,
    generalInfoForm: generalInfoFormEn,
    questionareForm: questionareFormEn,
    sidebar: sidebarEn,
    userHeader: userHeaderEn,
    upcomingCars: upcomingCarsEn,
    buyNow: buyNowEn,
    liveAuction: liveAuctionEn,
    carsInNegotiation: carsInNegotiationEn,
    specification: specificationEn,
    carEstimateAuction: carEstimateAuctionEn,
    gallery: galleryEn,
    myOrders: myOrdersEn,
    carContainer: carContainerEn,
    vehicleAddedSuccessModal: vehicleAddedSuccessModalEn,
    signUp: signupEn,
    footer: footerEn,
    priceIndicator: priceIndicatorEn,
    carAddedToSale: carAddedToSaleEn,
    bidHistory: bidHistoryEn,
    timeLeft: timeLeftEn,
    saleInformation: saleInformationEn,
    buyNowCarDetailReadOnly: buyNowCarDetailReadOnlyEn,
    negotiationList: negotiationListEn,
    carBiddingNegotiation: carBiddingNegotiationEn,
    carsInNegotiationDetails: carsInNegotiationDetailsEn,
    rejectedCars: rejectedCarsEn,
    carDetails: carDetailsEn,
    profile: profileEn,
    common: commonEn
  },
  fr: {
    header: headerFr,
    auth: authFr,
    myGarage: myGarageFr,
    sellMyCar: sellMyCarFr,
    generalInfoForm: generalInfoFormFr,
    questionareForm: questionareFormFr,
    sidebar: sidebarFr,
    userHeader: userHeaderFr,
    upcomingCars: upcomingCarsFr,
    buyNow: buyNowFr, 
    liveAuction: liveAuctionFr,
    carsInNegotiation: carsInNegotiationFr,
    specification: specificationFr,
    carEstimateAuction: carEstimateAuctionFr,
    gallery: galleryFr,
    myOrders: myOrdersFr,
    carContainer: carContainerFr,
    vehicleAddedSuccessModal: vehicleAddedSuccessModalFr,
    signUp: signupFr,
    footer: footerFr,
    priceIndicator: priceIndicatorFr,
    carAddedToSale: carAddedToSaleFr,
    bidHistory: bidHistoryFr,
    timeLeft: timeLeftFr,
    saleInformation: saleInformationFr,
    buyNowCarDetailReadOnly: buyNowCarDetailReadOnlyFr,
    negotiationList: negotiationListFr,
    carBiddingNegotiation: carBiddingNegotiationFr,
    carsInNegotiationDetails: carsInNegotiationDetailsFr,
    carDetails: carDetailsFr,
    rejectedCars: rejectedCarsFr,
    profile: profileFr,
    common: commonFr
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    ns: [
      "header", "auth", "footer", "myGarage", "generalInfoForm", "questionareForm", 
      "sidebar", "userHeader", "upcomingCars", "buyNow", "liveAuction", 
      "carsInNegotiation", "specification", "carEstimateAuction", "gallery", "myOrders", 
      "signUp", "vehicleAddedSuccessModal", "priceIndicator", "carAddedToSale",
      "bidHistory", "timeLeft", "saleInformation", "buyNowCarDetailReadOnly", "negotiationList",
      "carBiddingNegotiation", "carsInNegotiationDetails", "carDetails", "rejectedCars", "profile", "common"
    ],
    defaultNS: "header",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;